<template>
  <div>

    <router-link
      :to="cfg&&cfg.use_route? cfg.use_route :{
        name: 'asset', 
        params: {address: item.nft_address, id: (item.nft_id || item.ntf_id)},
        query: {owner: item.owner},
      }"
      v-if="item" 
      at_click="gotoItem(item)"
      :class="['d-block ui-card card-main-prod',{'status-checked':status_checked}]"
      >
      <div class="px-3 py-2 d-flex align-items-center">

        <span 
          @click.stop.prevent="toggleCheckItem()"
          v-if="cfg && cfg.is_card_checkable"
          class="btn-check-item"
          >
          <i class="fas fa-tag"></i>
        </span>

        <router-link @click.stop.prevent :to="{
            name: 'gallery',
            query: {
              addrfrom: item.owner || item.owner_info.address
            },
          }">
          <span class="ui-avatar size-25 mr-2">
            <img :src="item.owner_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
          </span>
          <span>
            <span v-if="item.owner_info && item.owner_info.username">
              <span v-if="item.owner_info.username.length <= 15">
                {{item.owner_info.username}}
              </span>
              <span v-else>
                {{item.owner_info.username.substr(0,13) + '...'}}
              </span>
            </span>
            <span v-else>
              {{item.owner | shortAddress}}
            </span>
          </span>
        </router-link>

        <span v-if="item_meme" class="ml-auto">
          <i 
            v-if="item_meme.name"
            @click.stop.prevent="share()"
            class="ui-icon-share op8 h-op10"
          ></i>
        </span>
      </div>
      <div>
        <div v-if="item_meme" class="pic-holder no-bg" style="height: 150px">
          <!-- <img :src="item_meme.image"> -->
          <CpNftCoverImg
            :src="item_meme.image"
          />
        </div>
      </div>
      <div class="px-3 py-2">
        <div>
          <h5 class="mt-1" style="
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;"
            >
            {{item_meme.name | transItemName}}
          </h5>
        </div>
        <div class="d-flex flex-wrap small box-more-info" style="height: 25px; overflow: hidden;">

          <div>
            <span v-if="item.sell_info.currency">
              <b class="c mr-2">
                {{item.sell_info.buyValue | qfw}}
                {{lg('',$store.state.web3.account_wallet.find(coin => coin.id == item.sell_info.currency).names)}}
              </b>

              <span class="usd-price t-gray">
                (${{item.sell_info.buyValue | tokenToUsd(item.sell_info.currency)}} 
                {{lg('',{
                  en: 'USD',
                  zh: '美元',
                })}})
              </span>
            </span>
            <span v-else class="b t-gray">
              {{lg('',{
                en: 'Not for sale',
                zh: '已被收藏/非卖品',
              })}}
            </span>
          </div>
          
        </div>

        <div class="d-flex flex-wrap small box-more-info" style="height: 25px; overflow: hidden;">

          <div>
            <div v-if="item.bid_info && item.bid_info.buyValue" class="b">
              Bid
              <span class="c upercase">
                {{item.bid_info.buyValue}}
                {{lg('',$store.state.web3.account_wallet.find(coin => coin.id == item.bid_info.currency).names)}}
              </span>
            </div>
            <!-- <div v-else>
              <span 
                click.stop.prevent="btnToggleBid()"
                class="b c"
                >
                {{lg('',{
                  en: 'Place a bid',
                  zh: '发起 Bid',
                })}}
              </span>
            </div> -->
          </div>

          <div class="ml-auto">
            <span @click.stop.prevent="setLikeStatus()" :class="['ml-auto h-c',{'c':status_liked}]">
              {{item.like_info.likeNum}}
              <i class="fa fa-heart"></i>
            </span>
          </div>

        </div>
      </div>
    </router-link>

    <!-- <popBid
      v-if="cfg_status_poppad_bid"
      :cfg_status_poppad="cfg_status_poppad_bid"
      :item="item_meme"
      :meta_item="data"
    /> -->
  </div>
</template>

<script>
import bus from '@/bus.js'
// import popBid from '../detail/pop_bid.vue'

export default {
  name: 'cardProduct',
  components: {
    // popBid,
  },
  props: [
    'data',

    // cfg: { is_card_checkable: true 卡片可被选, use_route: {name: 'xxx'}}
    'cfg',
  ],
  data() {
    return {
      item: null,
      item_meme: {},

      status_checked: false,

      // 
      cfg_status_poppad_bid: false,
    }
  },
  computed: {
    status_liked(){
      return this.uniCheckLikeStatus(this.item)
    },
  },
  watch: {

  },
  methods: {

    btnToggleBid(val){
      let v = this

      if(!v.$store.state.web3.account){
        bus.btnaccountvue.modalOpen = true
        return
      }

      v.cfg_status_poppad_bid = val!==undefined ? val : !v.cfg_status_poppad_bid
    },

    toggleCheckItem(){
      let v = this

      let old_mark = v.status_checked
      
      // uncheck others
      for(let i in v.$parent.$children){
        let child = v.$parent.$children[i]
        if(child.item && child.item_meme){
          child.status_checked = false
        }
      }

      v.status_checked = !old_mark

      if(v.status_checked){
        v.$parent.onCheckedItem(v.item,v.item_meme)
      }else{
        v.$parent.item = {}
        v.$parent.meta_item = {}
      }
    },

    share(){
      let v = this
      let mixed_item_data = Object.assign({},v.item,v.item_meme) 

      bus.appvue.showPopupShareItem(mixed_item_data)
    },

    async setLikeStatus(){
      let v = this
      let res = await v.uniSetLikeStatus(v.item, !v.status_liked)

      let mark = v.item.like_info.likeNum += (res?1:-1)
      v.item.like_info.likeNum = mark >= 0 ? mark : 0
    },
    
    async getData(){
      let v = this
      v.item = v.data

      let res = await v.uniFetchItemInfo(v.item)

      v.item_meme = res
    },

    // gotoItem(item){
    //   let v = this
    //   v.setListMetaData(item)
    //   v.$router.push({
    //     name: 'asset', 
    //     params: {address: item.nft_address, id: (item.nft_id || item.ntf_id)},
    //     query: {owner: item.owner},
    //   })
    // },

    setListMetaData(item){
      bus.last_meta_data_from_list = null
      bus.last_meta_data_from_list = item
    },
  },
  created() {
    this.getData()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>